import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _EngageIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M14 6.5C13.4477 6.5 13 6.94772 13 7.5C13 7.88867 13.2217 8.22556 13.5456 8.39104L12.0314 9.61731L11.3269 8.78087C10.976 8.36418 10.3561 8.30508 9.93273 8.64795L7.37061 10.7229C6.94142 11.0705 6.87527 11.7002 7.22286 12.1294C7.57044 12.5586 8.20014 12.6247 8.62933 12.2771L10.4291 10.8195L11.1336 11.656C11.4846 12.0727 12.1045 12.1318 12.5278 11.7889L15.034 9.75932C15.1482 10.1859 15.5374 10.5 16 10.5C16.5523 10.5 17 10.0523 17 9.5V7.5C17 6.94772 16.5523 6.5 16 6.5H14Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5.54348V15.0124C3.34237 15.0884 2.84021 15.5042 2.52971 15.9601C2.18251 16.4699 2 17.1184 2 17.7857V19.2143C2 19.8816 2.18251 20.5301 2.52971 21.0399C2.8734 21.5445 3.45194 22 4.21622 22H19.7838C20.5481 22 21.1266 21.5445 21.4703 21.0399C21.8175 20.5301 22 19.8816 22 19.2143V17.7857C22 17.1184 21.8175 16.4699 21.4703 15.9601C21.1598 15.5042 20.6576 15.0884 20 15.0124V5.54348C20 3.74019 18.7218 2 16.8276 2H7.17241C5.27824 2 4 3.74019 4 5.54348ZM7.17241 4C6.66701 4 6 4.53732 6 5.54348V15H18V5.54348C18 4.53732 17.333 4 16.8276 4H7.17241ZM4.18273 17.0859C4.21549 17.0378 4.24054 17.0125 4.25571 17H19.7443C19.7595 17.0125 19.7845 17.0378 19.8173 17.0859C19.9102 17.2225 20 17.4669 20 17.7857V19.2143C20 19.5331 19.9102 19.7775 19.8173 19.9141C19.7845 19.9622 19.7595 19.9875 19.7443 20H4.25571C4.24054 19.9875 4.21549 19.9622 4.18273 19.9141C4.08975 19.7775 4 19.5331 4 19.2143V17.7857C4 17.4669 4.08975 17.2225 4.18273 17.0859ZM19.7277 20.0107C19.7277 20.0107 19.73 20.0088 19.735 20.007C19.7303 20.0101 19.7277 20.0107 19.7277 20.0107ZM4.27231 20.0107C4.27231 20.0107 4.26974 20.0101 4.26502 20.007C4.27003 20.0088 4.27231 20.0107 4.27231 20.0107Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const EngageIcon = assignWithoutSideEffects(_EngageIcon, {
  componentId: 'EngageIcon',
});

export default EngageIcon;
